import React, { createContext, useContext, useState } from 'react';
import { combustibles } from '../data/combustibles';
import { realizarCalculoCompleto } from '../utils/calculatorUtils';

const CalculatorContext = createContext();

export const useCalculator = () => {
  const context = useContext(CalculatorContext);
  if (!context) {
    throw new Error('useCalculator debe ser usado dentro de CalculatorProvider');
  }
  return context;
};

export const CalculatorProvider = ({ children }) => {
  // Estado para controlar la aceptación de la política
  const [hasAcceptedPolicy, setHasAcceptedPolicy] = useState(false);
  
  // Estados del formulario
  const [email, setEmail] = useState('');
  const [empresa, setEmpresa] = useState('');
  const [combustible, setCombustible] = useState('');
  const [consumo, setConsumo] = useState('');
  const [resultados, setResultados] = useState(null);

  // Función para realizar el cálculo
  const calcular = () => {
    console.log('🔍 Iniciando cálculo...');
    console.log('Combustible:', combustible);
    console.log('Consumo:', consumo);
    
    if (!combustible || !consumo) {
      console.log('❌ Error: Campos vacíos');
      return {
        success: false,
        error: 'Por favor complete todos los campos'
      };
    }

    const combustibleSeleccionado = combustibles.find(c => c.id === combustible);
    
    if (!combustibleSeleccionado) {
      console.log('❌ Error: Combustible no encontrado');
      return {
        success: false,
        error: 'Combustible no encontrado'
      };
    }

    const resultadosCalculados = realizarCalculoCompleto(combustibleSeleccionado, consumo);
    
    if (!resultadosCalculados) {
      console.log('❌ Error: Fallo en cálculo');
      return {
        success: false,
        error: 'Error al realizar el cálculo. Verifique los datos ingresados.'
      };
    }

    console.log('✅ Cálculo exitoso:', resultadosCalculados);
    setResultados(resultadosCalculados);
    
    return {
      success: true,
      resultados: resultadosCalculados
    };
  };

  // Función para reiniciar todos los datos
  const reiniciar = () => {
    setEmail('');
    setEmpresa('');
    setCombustible('');
    setConsumo('');
    setResultados(null);
    setHasAcceptedPolicy(false); // También reiniciar la aceptación de política
  };

  const value = {
    // Estados
    email,
    empresa,
    combustible,
    consumo,
    resultados,
    combustibles,
    hasAcceptedPolicy,
    
    // Setters
    setEmail,
    setEmpresa,
    setCombustible,
    setConsumo,
    setHasAcceptedPolicy,
    
    // Funciones
    calcular,
    reiniciar
  };

  return (
    <CalculatorContext.Provider value={value}>
      {children}
    </CalculatorContext.Provider>
  );
};